const modulePrefix = 'network';

export const actionTypes = {
    UPDATE_NETWORK_STATUS: `${modulePrefix}/UPDATE_NETWORK_STATUS`,
};
